import React, { useState } from "react";
import { Form, Formik } from "formik";
import BackButton from "./BackButton";
import SubmitButton from "./SubmitButton";
import HandSubmitAndAddAnotherCameraButton from "./HandleSubmitAndAddAnotherCameraButton";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

const Wizard = ({
  children,
  initialValues,
  onSubmit,
  setVisibleScreen,
  responseObject,
  errorState,
  choicesChanger,
  stepNumber,
  setStepNumber,
  setCameraCheckFinsihedAlertOpen,
  setGoodCameras,
  setConnectivityCameras,
  setLowResolutionCameras,
  setCameraCheckResultDownloadURL,
  nextOrSubmitButtonDisabled,
}: {
  children: any;
  initialValues: any;
  onSubmit: any;
  setVisibleScreen: any;
  responseObject: any;
  errorState: any;
  choicesChanger: any;
  stepNumber: any;
  setStepNumber: any;
  setCameraCheckFinsihedAlertOpen: any;
  setGoodCameras: any;
  setConnectivityCameras: any;
  setLowResolutionCameras: any;
  setCameraCheckResultDownloadURL: any;
  nextOrSubmitButtonDisabled: any;
}) => {
  const steps = React.Children.toArray(children);
  const [snapshot, setSnapshot] = useState(initialValues);
  const [buttonDisabled, setButtonDisabled] = React.useState(true);

  const step: any = steps[stepNumber];
  const totalSteps = steps.length;
  const isLastStep = stepNumber === totalSteps - 1;

  const next: any = (values: any) => {
    setSnapshot(values);
    setStepNumber(Math.min(stepNumber + 1, totalSteps - 1));
  };

  const previous = (values: any) => {
    setSnapshot(values);
    setStepNumber(Math.max(stepNumber - 1, 0));
  };

  const handleSubmit = async (values: any, bag: any) => {
    if (step.props.onSubmit) {
      await step.props.onSubmit(values, bag);
    }
    if (isLastStep) {
      return onSubmit(values, bag);
    } else {
      bag.setTouched({});
      next(values);
    }
  };

  const softguardAlertsBoolean =
    Object.keys(initialValues).includes("user_ext");

  return (
    <Formik
      initialValues={snapshot}
      onSubmit={handleSubmit}
      validationSchema={step.props.validationSchema}
    >
      <Form>
        <p className={"font-mulish text-[#283E6D]"}>
          {`Step ${stepNumber + 1} of ${totalSteps}`}
        </p>
        <p className={"font-mulish text-[#283E6D] pt-[10px]"}>
          {softguardAlertsBoolean && stepNumber === 2 && `Softguard Alert Info`}
        </p>
        <br></br>
        {step}
        {location.href.includes("addcamera") &&
          localStorage.integrationType === "1" &&
          localStorage.firstCameraAdded === "true" &&
          stepNumber === 1 && (
            <FormControlLabel
              sx={{
                fontFamily: "Mulish",
                color: "#001943",
              }}
              label="Copy Values"
              control={
                <Checkbox
                  color="primary"
                  defaultChecked
                  onChange={(event: any, result: any) => {
                    if (result === true) {
                      localStorage.setItem("copyValues", "true");
                    } else {
                      localStorage.setItem("copyValues", "false");
                    }
                  }}
                />
              }
            />
          )}
        <div></div>
        <br></br>
        {/*
          The footer buttons are absolutely positioned. Before ENG-2144 this
          row had no height, so they hung off the bottom of the wizard (and
          of the document): the page could scroll only to the button's bottom
          edge, and the lower part of "+ Submit and Add Another Camera" sat
          outside the reachable area. The row now has real height and bottom
          space and is the buttons' containing block, so they always end
          inside the scrollable page.
        */}
        <div
          className="relative flex h-[40px] mb-10"
          data-testid="wizard-footer"
        >
          {stepNumber > 0 && <BackButton previous={previous} />}
          <SubmitButton
            next={next}
            isLastStep={isLastStep}
            errorState={errorState}
            choicesChanger={choicesChanger}
            buttonDisabled={buttonDisabled}
            setButtonDisabled={setButtonDisabled}
            nextOrSubmitButtonDisabled={nextOrSubmitButtonDisabled}
          />
          {location.href.includes("addcamera") && (
            <HandSubmitAndAddAnotherCameraButton
              isLastStep={isLastStep}
              setVisibleScreen={setVisibleScreen}
              responseObject={responseObject}
              buttonDisabled={buttonDisabled}
              setCameraCheckFinsihedAlertOpen={setCameraCheckFinsihedAlertOpen}
              setGoodCameras={setGoodCameras}
              setConnectivityCameras={setConnectivityCameras}
              setLowResolutionCameras={setLowResolutionCameras}
              setCameraCheckResultDownloadURL={setCameraCheckResultDownloadURL}
            />
          )}
        </div>
      </Form>
    </Formik>
  );
};

export default Wizard;
